export const environment = {
    production: true,
    assetsUrl: 'https://rifmdatabase.rifm.org/rifmweb/',
    appUrl: 'https://rifmdatabase.rifm.org/rifmwebapi',
    apiUrl: 'https://rifmdatabase.rifm.org/rifmwebapi/api'
};
